<ng-template #modalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ title }}</h4>
  </div>
  <div class="modal-body box-parent">
    <div class="row">
      <div class="col">
        <div class="form-label-group">
          <input type="text" id="un" class="form-control" [(ngModel)]="product.product_id" placeholder="{{'PRODUCT.LIST.FILTER.PRODUCT-ID' | translate}}">
          <label for="un">{{'PRODUCT.LIST.FILTER.PRODUCT-ID' | translate}}</label>
        </div>
        <div class="form-label-group">
          <input type="text" id="un" class="form-control" [(ngModel)]="product.name_en" placeholder="{{'PRODUCT.LIST.FILTER.PRODUCT-NAME' | translate}}">
          <label for="un">{{'PRODUCT.LIST.FILTER.PRODUCT-NAME' | translate}}</label>
        </div>
        <div class="form-label-group">
          <p-dropdown
            [(ngModel)]="product.vat"
            [options]="vats"
            optionValue="value"
            placeholder="Select VAT"
            (ngModelChange)="dropdownChange($event)"
            class="dv-dropdown">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer m-b-0">
      <div class="col">
        <div class="row m-b-5">
          <div class="col text-center text-red">{{ errorMessage ? errorMessage : '&nbsp;' }}</div>
        </div>
        <div class="row justify-content-center">
          <div class="col">
            <button class="btn btn-dv btn-clean btn-wide m-r-20" (click)="modalRef.hide()">{{'COMMON.CANCEL' | translate}}</button>
          </div>
          <button class="col-auto btn btn-dv btn-wide pull-right" (click)="submit()">{{ createMode ? ('PROFILE.PASSWORD.CONFIRM' | translate) : ('PROFILE.LIST.MODAL.SAVE' | translate) }}</button>
        </div>
      </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list-detail/product-list-detail.component.html